import { useState } from 'react'

export default function App() {
  const [bill, setBill] = useState(0);
  const [yourBill, setYourBill] = useState(0);
  const [frndBill, setFrndBill] = useState(0);
  const [totalBill, setTotalBill] = useState(0);
  const [tip, setTip] = useState(0);
  const [isShow, setIsShow] = useState(false);
  const [alert, setAlert] = useState("none");

  const handleBill = () => {
    if (!bill) {
      setAlert("block");
      setTimeout(() => {
        setAlert("none");
      }, 1500);
    } else {
      const otherBill = (yourBill + frndBill) / 2;
      const tipBill = (otherBill * bill) / 100;
      const totBill = bill + tipBill;
      setTip(() => tipBill);
      setTotalBill(() => totBill);
      setIsShow(true);
    }
  };

  const resetBill = () => {
    setBill(0);
    setYourBill(0);
    setFrndBill(0);
    setTotalBill(0);
    setTip(0);
    setIsShow(false);
  };

  return (
    <div className="bill-box">
      <h2>Tip Calculator</h2>
      <div className="input-box">
        <Bill onSetBill={setBill} onBill={bill} onAlert={alert} />
        <TipPercentage
          title="How did you like the service?"
          SetYourBill={setYourBill}
          YourBill={yourBill}
        />
        <TipPercentage
          title="How much did your frind like the service?"
          SetYourBill={setFrndBill}
          YourBill={frndBill}
        />
        <BillBox
          onIsShow={isShow}
          onBill={bill}
          onTip={tip}
          onTotalBill={totalBill}
        />
        <BillControl
          onHandleBill={handleBill}
          onResetBill={resetBill}
          onIsShow={isShow}
        />
      </div>
    </div>
  );
}

function Bill({ onSetBill, onBill, onAlert }) {
  return (
    <div className="form-data">
      <label>How much was the bill?</label>
      <input
        type="text"
        placeholder="Bill Amount"
        value={onBill}
        onChange={(e) => onSetBill(+e.target.value)}
      />
      <span className="msg" style={{ display: onAlert }}>
        Enter the bill amount
      </span>
    </div>
  );
}

function TipPercentage({ title, SetYourBill, YourBill }) {
  return (
    <div className="form-data">
      <label>{title}</label>
      <select value={YourBill} onChange={(e) => SetYourBill(+e.target.value)}>
        <option value="0">Dissatisfied (0%)</option>
        <option value="10">It was good (10%)</option>
        <option value="15">It was very good (15%)</option>
        <option value="20">It was fantastic (20%)</option>
      </select>
    </div>
  );
}

function BillBox({ onIsShow, onBill, onTip, onTotalBill }) {
  return (
    <>
      {onIsShow && (
        <div className="generate-bill">
          <p>Your final bill</p>
          <h3>₹{onTotalBill}</h3>
          <p>
            You pay ₹{onTotalBill} (₹{onBill} + ₹{onTip} tip)
          </p>
        </div>
      )}
    </>
  );
}

function BillControl({ onHandleBill, onResetBill, onIsShow }) {
  return (
    <>
      <button className="bill-btn" onClick={onHandleBill}>
        Total Bill
      </button>
      {onIsShow && (
        <button className="reset-btn" onClick={onResetBill}>
          New Bill
        </button>
      )}
    </>
  );
}
